import { StyleSheet, View } from 'react-native';
import { NavigationProp, useNavigation } from '@react-navigation/native';
import { Divider, Text, useTheme } from '@ui-kitten/components';

import CalendarIcon from '../../../Assets/calendar.svg';
import UrlParameterHelper from '../../../Helper/UrlParameter';
import routeList, { ReservationNavigatorProps } from '../../../Routes/list';
import themeStyle from '../../../Theme/styles';

import Button from '../../Button';
import Image from '../../Image';
import ListItem from '../../ListItem';

type Data = {
  date?: string;
  description?: string;
  image: string;
  isEvent?: boolean;
  isLast: boolean;
  link?: string;
  location?: string;
  name: string;
  time?: string;
};

type ItemContentProps = Data & { storeName: string; onBook?: () => void };

const ItemContent = ({ onBook, ...data }: ItemContentProps) => {
  const theme = useTheme();
  const navigation = useNavigation<NavigationProp<ReservationNavigatorProps>>();
  const {
    date,
    description,
    image,
    isEvent,
    isLast,
    link,
    location,
    name,
    storeName,
    time,
  } = data;

  const _onPress = (e) => {
    e?.preventDefault?.();
    const linkAsObject = UrlParameterHelper.getUrlParameter(link);
    if (isEvent) {
      navigation.navigate(
        routeList.RES_EVENT_DETAILS,
        linkAsObject as ReservationNavigatorProps[routeList.RES_EVENT_DETAILS],
      );
    } else {
      onBook?.();
    }
  };

  return (
    <Button onPress={_onPress} plain>
      <View
        accessibilityRole="link"
        // @ts-ignore: href works on link role, but on rn it throw warning
        href={link}
        style={styles.container}
        target="_blank"
      >
        <Image
          source={{ uri: image }}
          style={styles.image}
          resizeMode="cover"
        />
        <View style={themeStyle.flex1}>
          <Text style={[themeStyle.bold, themeStyle.spacingBottomXSmall]}>
            {name}
          </Text>
          {Boolean(description) && (
            <Text category="p2" numberOfLines={1}>
              {description}
            </Text>
          )}
          <ListItem
            contentContainerStyle={themeStyle.spacingBottomXSmall}
            leftIcon={{
              name: 'shopping-bag',
              color: theme['color-info-500'],
              size: 20,
            }}
            title={<Text category="p2">{storeName}</Text>}
            spacing={5}
          />
          {Boolean(location) && (
            <ListItem
              contentContainerStyle={themeStyle.spacingBottomXSmall}
              leftIcon={{
                name: 'pin',
                color: theme['color-info-500'],
                size: 20,
              }}
              title={<Text category="p2">{location}</Text>}
              spacing={5}
            />
          )}
          {Boolean(date) && Boolean(time) && (
            <ListItem
              leftIcon={{
                svg: CalendarIcon,
                color: theme['color-info-500'],
                size: 20,
              }}
              title={
                <Text category="p2">
                  {date} | {time}
                </Text>
              }
              spacing={5}
            />
          )}
        </View>
      </View>
      {!isLast && <Divider style={themeStyle.divider} />}
    </Button>
  );
};

const styles = StyleSheet.create({
  container: {
    ...themeStyle.flex1,
    ...themeStyle.flexDirectionRowCenter,
    ...themeStyle.pageVerticalSpacing,
    ...themeStyle.pageHorizontalSpacing,
  },
  image: {
    ...themeStyle.spacingRight,
    width: 60,
    height: 60,
    borderRadius: 30,
  },
});

export default ItemContent;
